import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
const BASE_URL = process.env.REACT_APP_BASE_URL;
console.log(BASE_URL, "BASE_URLBASE_URLBASE_URLBASE_URL");
export const fetchContacts = createAsyncThunk(
  "contacts/fetchContacts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/telegram/get-user`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data.tgContactList;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fatchUser = createAsyncThunk(
  "contacts/fatchUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/telegram/get-conversation`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fatchNewUser = createAsyncThunk(
  "contacts/fatchNewUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/telegram/get-new-conversation`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchConversationById = createAsyncThunk(
  "conversation/fetchById",
  async (chatId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/telegram/get-conversations/${chatId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response, "response.dataresponse.dataresponse.data");
      return response.data;
    } catch (err) {
      console.log(err, "---------------------errerrcccc-------");
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const telegramSendmessages = createAsyncThunk(
  "telegram/sendMessages",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/telegram/send-message`,
        { data },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response, "response.dataresponse.dataresponse.data");
      return response.data;
    } catch (err) {
      console.log(err, "---------------------errorSendMessage-------");
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const tgDisconnect = createAsyncThunk(
  "contacts/tgDisconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/tg/disconnect`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const telegramLogin = createAsyncThunk(
  "telegram/login",
  async (phoneNumber, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/telegram/login`,
        { phoneNumber: phoneNumber },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response, "telegram/logintelegram/login");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const telegramVerifyOTP = createAsyncThunk(
  "telegram/telegramVerifyOTP",
  async (data, { rejectWithValue }) => {
    console.log(data, "----------telegramVerifyOTP-----------");
    try {
      const response = await axios.post(`${BASE_URL}/telegram/verify`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(response, "telegram/logintelegram/login");
      console.log(response.data, " response.data response.data");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const tgSendFile = createAsyncThunk(
  "telegram/send-file",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/telegram/send-file`, { userId: data.userId, file: data.file }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const tgRealTime = createAsyncThunk(
  "telegram/chat/realtime",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/telegram/chat/realtime`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
// export const NewAsync = async () => {
//     const token = Cookies.get('token')
//     console.log(token, "tokentokentokentokentoken")
//     try {
//         const response = await axios.post(`${BASE_URL}/telegram/get-conversations`, {
//             headers: {
//                   Authorization: `Bearer ${Cookies.get("token")}`
//             },
//         });
//         console.log(response.data, "response.dataresponse.dataresponse.data");
//         return response.data;
//     } catch (err) {
//         console.log(err, "11111111111111111111111111111111----------------------------")
//         return err;
//     }
// };
